/**
 * Removes diacritics (accents) from a string.
 * Example: ÁáÀàÂâÃãÄäÅå -> a, Óòõöő -> o, Ññ -> n, Çç -> c.
 */
export function removeDiacritics(input: string | null | undefined): string {
  if (!input) return '';

  return input
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim();
}
